// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2b0eg","top":"styles_top__3DWq9","left":"styles_left__3Yqbu","description":"styles_description__F6VW1"};